import { create } from "zustand";

export type LayoutMode = "default" | "fold" | "popup";

interface LayoutState {
  layoutMode: LayoutMode;
  setLayoutMode: (mode: LayoutMode) => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  layoutMode: "default",
  setLayoutMode: (mode) => set({ layoutMode: mode }),
}));
